import React from 'react';

export default class AddToCartComponent extends React.PureComponent {
  componentDidMount = () => {
    const buttonEl = document.getElementById(this.props.uniqId);
    if (buttonEl) buttonEl.onclick = this.props.addProductToCart;
  }

  render() {
    return (
      <React.Fragment>
        <span className="cart-list">
          <span className="tooltip">{this.props.text}</span>
          <svg className="icon icon-cart">
            <use xlinkHref="#icon-cart" />
          </svg>
        </span>
        <button id={this.props.uniqId} className="cart-list-click" type="button" />
      </React.Fragment>
    );
  }
}
